export { default } from 'features/diagnostics';
